class HubspotModal {
  constructor(modal) {
    this.modal = modal;
    this.dialog = this.modal.querySelector(".hubspot-modal__dialog");
    this.triggerAnchor = this.modal.dataset.hubspotModal;
    this.formTarget = this.modal.querySelector("[data-hubspot-form-target]");
    this.formInitialized = false;
    this.formInitializing = false;

    this.init();
  }

  init() {
    this.initForm();
    this.bindOpen();
    this.bindClose();
    this.bindKeyboard();
    this.openFromHash();
  }

  open() {
    this.modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hubspot-modal-open");
    this.initForm();
  }

  close() {
    this.modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hubspot-modal-open");

    if (this.isMatchingTrigger(window.location.hash)) {
      history.replaceState(
        null,
        document.title,
        `${window.location.pathname}${window.location.search}`,
      );
    }
  }

  bindOpen() {
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("a[href]");

      if (!trigger) return;
      if (!this.isMatchingTrigger(trigger.getAttribute("href"))) return;

      event.preventDefault();
      this.open();
    });
  }

  bindClose() {
    this.modal.addEventListener("click", (event) => {
      if (
        event.target.matches("[data-modal-close]") ||
        !this.dialog.contains(event.target)
      ) {
        this.close();
      }
    });
  }

  bindKeyboard() {
    document.addEventListener("keydown", (event) => {
      if (this.modal.getAttribute("aria-hidden") !== "false") return;

      if (event.key === "Escape") {
        this.close();
      }
    });
  }

  openFromHash() {
    if (this.isMatchingTrigger(window.location.hash)) {
      this.open();
    }
  }

  isMatchingTrigger(href) {
    return href === `#${this.triggerAnchor}`;
  }

  initForm() {
    if (!this.formTarget || this.formInitialized || this.formInitializing) {
      return;
    }

    this.formInitializing = true;

    HubspotModal.loadFormScript()
      .then(() => {
        if (!window.hbspt?.forms?.create) return;

        window.hbspt.forms.create({
          region: this.formTarget.dataset.region,
          portalId: this.formTarget.dataset.portalId,
          formId: this.formTarget.dataset.formId,
          target: `#${this.formTarget.id}`,
        });

        this.formInitialized = true;
      })
      .catch((error) => {
        console.error("Failed to initialize HubSpot form", error);
      })
      .finally(() => {
        this.formInitializing = false;
      });
  }

  static loadFormScript() {
    if (window.hbspt?.forms?.create) {
      return Promise.resolve();
    }

    if (window.__hubspotFormsScriptPromise) {
      return window.__hubspotFormsScriptPromise;
    }

    window.__hubspotFormsScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        'script[src="https://js.hsforms.net/forms/embed/v2.js"]',
      );

      if (existingScript) {
        existingScript.addEventListener("load", resolve, { once: true });
        existingScript.addEventListener(
          "error",
          () => reject(new Error("HubSpot forms script failed to load")),
          { once: true },
        );
        return;
      }

      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/embed/v2.js";
      script.charset = "utf-8";
      script.type = "text/javascript";
      script.async = true;
      script.addEventListener("load", resolve, { once: true });
      script.addEventListener(
        "error",
        () => reject(new Error("HubSpot forms script failed to load")),
        { once: true },
      );
      document.head.appendChild(script);
    });

    return window.__hubspotFormsScriptPromise;
  }
}

document.querySelectorAll("[data-hubspot-modal]").forEach((modal) => {
  new HubspotModal(modal);
});
